import {
  BOOK_SKI_PASS_STORAGE_KEY,
  CHECKOUT_STORAGE_KEY,
  CHECKOUT_URL_STORAGE_KEY,
  ROUTE_RESTORATION_FLAG,
} from '@/shared/constants/storage-keys';
import { useBookSkiPassStore } from '@/store/book-ski-pass.store';

export function clearCheckoutSessionAfterPayment(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(CHECKOUT_STORAGE_KEY);
  window.sessionStorage.removeItem(CHECKOUT_URL_STORAGE_KEY);
}

export function setupFunnelStorageSync(): () => void {
  if (typeof window === 'undefined') return () => {};

  const handleStorage = (e: StorageEvent) => {
    if (e.key !== BOOK_SKI_PASS_STORAGE_KEY && e.key !== CHECKOUT_STORAGE_KEY) return;
    if (e.newValue != null) return;

    useBookSkiPassStore.getState().reset();
    window.sessionStorage.removeItem(ROUTE_RESTORATION_FLAG);
  };

  window.addEventListener('storage', handleStorage);
  return () => window.removeEventListener('storage', handleStorage);
}
